import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionExpiredService } from '../../services/session-expired-service';
import { tap } from 'rxjs';

export const sessionResetInterceptor: HttpInterceptorFn = (req, next) => {

  const sessionExpiredService = inject(SessionExpiredService);
  return next(req).pipe(tap(() => sessionExpiredService.resetTimer()));
};
